module.exports = __webpack_public_path__ + "static/media/amex.fb803771.svg";